import { Complete } from 'game/scenes/Complete';
import { Onboarding } from 'game/scenes/Onboarding';
import HowToPlay from 'game/scenes/HowToPlay';
import LevelSelect from '../scenes/LevelSelect';
import Welcome from '../scenes/Welcome';
import EndlessSoapBar from '../scenes/games/EndlessSoapBar';
import FeedTheBirds from '../scenes/games/FeedTheBirds';
import KeepOutTheCold from '../scenes/games/KeepOutTheCold';
import BeeKind from '../scenes/games/BeeKind';
import FriendlyFlora from '../scenes/games/FriendlyFlora';
import WaterSaviour from '../scenes/games/WaterSaviour';
import EnergySaver from '../scenes/games/EnergySaver';
import EcoExpert from '../scenes/games/EcoExpert';

export const KEYS = {
  Boot: 'Boot',
  Load: 'Load',
  Welcome: 'Welcome',
  HowToPlay: 'HowToPlay',
  Onboarding: 'Onboarding',
  Complete: 'Complete',
  LevelSelect: 'LevelSelect',
  FeedTheBirds: 'FeedTheBirds',
  KeepOutTheCold: 'KeepOutTheCold',
  BeeKind: 'BeeKind',
  EndlessSoapBar: 'EndlessSoapBar',
  FriendlyFlora: 'FriendlyFlora',
  WaterSaviour: 'WaterSaviour',
  EnergySaver: 'EnergySaver',
  EcoExpert: 'EcoExpert',
};

export const SCENE_MAP = [
  { key: KEYS.Welcome, state: Welcome },
  { key: KEYS.Complete, state: Complete },
  { key: KEYS.HowToPlay, state: HowToPlay },
  { key: KEYS.Onboarding, state: Onboarding },
  { key: KEYS.LevelSelect, state: LevelSelect },
  { key: KEYS.FeedTheBirds, state: FeedTheBirds },
  { key: KEYS.KeepOutTheCold, state: KeepOutTheCold },
  { key: KEYS.BeeKind, state: BeeKind },
  { key: KEYS.EndlessSoapBar, state: EndlessSoapBar },
  { key: KEYS.FriendlyFlora, state: FriendlyFlora },
  { key: KEYS.WaterSaviour, state: WaterSaviour },
  { key: KEYS.EnergySaver, state: EnergySaver },
  { key: KEYS.EcoExpert, state: EcoExpert },
];
